import React, {PropTypes} from 'react';
import {Map} from 'immutable';

export default class AdditionalScores extends React.Component {
    static propTypes = {
        additionalScores: PropTypes.arrayOf(PropTypes.number),
        scores: PropTypes.instanceOf(Map),
        additionalScoreElement: PropTypes.func.isRequired
    };

    static renderAdditionalScore(scoreId, props) {
        const scoreProps = {
            scoreId
        };

        const Comp = props.additionalScoreElement;

        return (<Comp key={scoreId} {...scoreProps}/>);
    }

    render() {
        const {additionalScores} = this.props;

        if (additionalScores === undefined || additionalScores.length === 0) {
            return false;
        }

        return (
            <span className="score-full">
                {additionalScores.map(s => AdditionalScores.renderAdditionalScore(s, this.props))}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/AdditionalScores.jsx